import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgChartsModule } from 'ng2-charts';


import { CommonService } from '../../services/common.service';
import { CompanyService } from '../../services/company.service';
import { CompanyComponent } from './company.component';
import { CompanyDashboardComponent } from './dashboard/company-dashboard.component';
import { DatabaseComponent } from './database/database.component';
import { ItemInfoComponent } from './item-info/item-info.component';
import { CompanyOrderInfoComponent } from './order-info/company-order-info.component';
import { CompanyOrderListComponent } from './order-list/company-order-list.component';
import { PhotographersComponent } from './photographers/photographers.component';
import { SidebarCustomorderComponent } from './sidebar-customorder/sidebar-customorder.component';
import { SidebarEditinfoComponent } from './sidebar-editinfo/sidebar-editinfo.component';
import { SidebarRejectComponent } from './sidebar-reject/sidebar-reject.component';
import { TemplatesComponent } from './templates/templates.component';
import { SharedModule } from '../../shared/shared.module';
import { CompanyRouting } from '../../routes/company.routing';
import { PhotographerOrdersComponent } from './photographer-orders/photographer-orders.component';
import { PhotographerFilterComponent } from './filters/photographer-filter/photographer-filter.component';
import { WarehouseFilterComponent } from './filters/warehouse-filter/warehouse-filter.component';
import { StyleGroupFilterComponent } from './filters/style-group-filter/style-group-filter.component';
import { StyleDescriptionFilterComponent } from './filters/style-description-filter/style-description-filter.component';
import { PurposeFilterComponent } from './filters/purpose-filter/purpose-filter.component';
import { TeamFilterComponent } from './filters/team-filter/team-filter.component';
import { ShopSellingPeriodFilterComponent } from './filters/shop-selling-period-filter/shop-selling-period-filter.component';
import { BrandCategoryComponent } from './filters/brand-category-filter/brand-category-filter.component';
import { PhotographerStatusFilterComponent } from './filters/photographer-status-filter/photographer-status-filter.component';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { UiAvatarImageComponent } from '../../shared/libs/up-header/ui-avatar/ui-avatar-image.component';
import { UpTopHeaderComponent } from '../../shared/libs/up-header/up-top-header/up-top-header.component';
import { SettingsComponent } from './settings/settings.component';
import { MatTabsModule } from '@angular/material/tabs';
import { HasRoleDirective } from '../../services/directives/has-role.directive';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgChartsModule,
    SharedModule,
    CompanyRouting,
    // Material Import:
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatChipsModule,
    MatIconModule,
    UiAvatarImageComponent,
    UpTopHeaderComponent,
    MatTabsModule,
    HasRoleDirective
  ],
  declarations: [
    CompanyComponent,
    CompanyDashboardComponent,
    CompanyOrderListComponent,
    DatabaseComponent,
    PhotographersComponent,
    TemplatesComponent,
    ItemInfoComponent,
    CompanyOrderInfoComponent,
    SidebarEditinfoComponent,
    SidebarCustomorderComponent,
    SidebarRejectComponent,
    PhotographerOrdersComponent,
    // Filter Components:
    BrandCategoryComponent,
    PhotographerFilterComponent,
    WarehouseFilterComponent,
    StyleGroupFilterComponent,
    StyleDescriptionFilterComponent,
    PurposeFilterComponent,
    TeamFilterComponent,
    ShopSellingPeriodFilterComponent,
    PhotographerStatusFilterComponent,
    SettingsComponent,
  ],
  exports: [CompanyComponent],
  providers: [CompanyService, CommonService]
})
export class CompanyModule { }
